import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

const LandingPage = () => {
  return (
    <Grid className="login-page-wrapper landing-page-wrapper" container dir="ltr">
      <Grid className="login-form-block" xs={12} md={6} style={{ textAlign: 'left' }}>
        <h3 className="landing-heading">Dawa Company for Electronic Invitations with Personal Barcode</h3>
        <p className="landing-subtitle">
          Dawa is a specialized company in organizing events, conferences, and graduation ceremonies.
          Dawa — For Your Happy Occasion.
        </p>
        <div className="landing-actions">
          <Button
            className="landing-cta"
            variant="contained"
            color="primary"
            onClick={() => (window.location.href = '/privacy-policy')}
          >
     Privacy Policy
          </Button>

        </div>
      </Grid>
      <Grid
        className="cover-img-wrapper"
        xs={12}
        md={6}
        style={{ backgroundImage: 'url("/dawa.png")' }}
      />
    </Grid>
  );
};

export default LandingPage;


